export default __webpack_public_path__ + "76fd21e018ef3661328cfd2968d65e48.svg";